import { useMemo } from "react";

import { useCmmdWorkIntakeSnapshot } from "../cmmd/workIntakeResource";
import {
  forgeCloudEnvironmentNamingContextFromIntake,
  type ForgeCloudEnvironmentNamingContext,
} from "./forgeCloudEnvironmentLabel";

/**
 * The naming context for Environment labels, kept current with the work intake.
 *
 * Every surface that labels an Environment row reads this, so an Organization
 * whose name arrives after first paint renames its rows without a reload.
 */
export function useForgeCloudEnvironmentNamingContext(): ForgeCloudEnvironmentNamingContext {
  const { workspaces, projects, identity } = useCmmdWorkIntakeSnapshot();
  return useMemo(
    () => forgeCloudEnvironmentNamingContextFromIntake({ workspaces, projects, identity }),
    [workspaces, projects, identity],
  );
}
